// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__mB3xy","title":"AfterBackImages_title__12YYF","images":"AfterBackImages_images__2yV0t"};